// Regex constants
const COMBINATION_NUMBER_FORMAT_REGEX = /(\d{3})(\d{3})(\d{2})/;

// Format a combination number e.x "93364965" -> "933.649.65"
export const formatCombinationNumber = (number: string): string =>
  number.replace(COMBINATION_NUMBER_FORMAT_REGEX, "$1.$2.$3");
